import React from "react";
import AnalysisForm from "../../../shared/components/form/events-form/AnalysisForm";
import Page from "../../../shared/components/Page";
import {PLATFORM_FEATURE_CONTENTS, PLATFORM_PERMISSION_EDITOR} from "../../../shared/helpers/features";


const AnalysisAdd = () => {
  return (
    <Page
      feature={PLATFORM_FEATURE_CONTENTS}
      permission={PLATFORM_PERMISSION_EDITOR} onlyOnline
    >
      <AnalysisForm />
    </Page>
  )
}


export default AnalysisAdd;
